<template>
  <div class="leading">
    <div class="content">
      <img class="back_img" :src="imgPath + 'yijiu_linqu1.png'" alt />
      <div class="pos_wei" v-if="info.packet">
        <img class="user_img" :src="info.packet.share_avatar" alt />
        <p class="user_name">
          <!-- {{info.packet.share_name}}的红包 -->
        </p>
        <p class="user_title">
          在这里遇见有温度的商家，任性抢
          红包，任性去选购
        </p>
        <div class="price">
          <span class="user_price">{{info.packet_user.price_dollar}}</span>
          <span class="user_sl">元</span>
        </div>
        <p class="user_footer">
          <span class="user_card">购物券红包，已放入您的券包中</span>
          <!-- <span class="user_go" @click="jump('redList')">去查看</span> -->
        </p>
      </div>
    </div>
    <div class="btn" @click="jump('discount')">去使用</div>
    <p class="go_index" @click="jump('homeIndex')">商城首页</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      signNo: '',
      id: '',
      info: {},
    }
  },
  created() {
    this.signNo = this.$route.query.signNo
    this.id = this.$route.query.id
  },
  mounted() {
    this.getPacketDetail()
  },
  methods: {
    jump(e) {
      this.$router.push({ path: e })
    },
    //获取红包详情
    getPacketDetail() {
      this.http('MemberRedPacket.packetDetail', {
        packet_id: this.id,
        share_sign_no: this.signNo,
      }).then((e) => {
        this.info = e.content
        console.log(e)
      })
    },
  },
}
</script>

<style scoped lang="scss">
.leading {
  min-height: 100vh;
  background: rgba(242, 243, 245, 1);
  .content {
    position: relative;
    z-index: 100;
    .back_img {
      width: 100%;
      height: 164px;
    }
    .pos_wei {
      width: 100%;
      // position: absolute;
      // left: 50%;
      // transform: translate(-50%);
      top: 94px;
      background: #ffffff;
      .user_img {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%);
        top: 94px;
        display: block;
        width: 140px;
        height: 140px;
        border: 1px solid #ffffff;
        margin: 0 auto;
        border-radius: 50%;
      }
      .user_name {
        padding-top: 88px;
        font-size: 30px;
        font-weight: 700;
        color: #323233;
        text-align: center;
      }
      .user_title {
        width: 360px;
        font-size: 24px;
        color: #999999;
        text-align: center;
        margin-top: 10px;
        margin-left: 195px;
      }
      .price {
        text-align: center;
        margin-top: 18px;
        .user_price {
          font-size: 88px;
          color: #ee0a24;
        }
        .user_sl {
          font-size: 26px;
          color: #999999;
        }
      }
      .user_footer {
        padding: 42px 190px;
        .user_card {
          font-size: 26px;
          color: #999999;
        }
        .user_go {
          font-size: 26px;
          color: #4983ff;
          padding-left: 20px;
        }
      }
    }
  }
  .btn {
    font-size: 32px;
    color: #ffffff;
    background: #ee0a24;
    border-radius: 44px;
    width: 686px;
    height: 88px;
    line-height: 88px;
    text-align: center;
    margin: 20px auto;
  }
}
.go_index {
  text-align: center;
  padding: 20px;
  font-size: 28px;
}
</style>